import { Menu as MuiMenu, styled } from "@mui/material";

const CustomMenu = styled(MuiMenu)({
  "& .MuiPaper-root": {
    border: "1px solid",
    maxWidth: "360px",
  },
  "& .MuiList-root": {
    padding: 0,
  },
  li: {
    paddingTop: "0.8rem",
    paddingBottom: "0.8rem",
    paddingRight: "1.4rem",
    paddingLeft: "0.8rem",
    justifyContent: "center",
  },
});

export default function Menu({ anchorEl, onClose, labelledBy, children }) {
  const open = Boolean(anchorEl);

  return (
    <CustomMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        "aria-labelledby": labelledBy,
      }}
      sx={{ border: "1px solid" }}
    >
      {children}
    </CustomMenu>
  );
}
